import { CustomEventWithDefaults } from './custom-event-with-defaults.js';

class CrntFocusEvent extends CustomEventWithDefaults {
  constructor() {
    super("crnt-focus");
  }
}

export { CrntFocusEvent };
